import React from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./Modules.css";
import { Button } from "@mui/material";

const Klantenservice = () => {
  const navigate = useNavigate();

  return (
    <div className="main-container">
      <span>Klantenservice</span>
    </div>
  );
};

export default Klantenservice;
